export default __webpack_public_path__ + "static/media/x33mall-banner-ms.26d7e867.jpg";